import router from '@/router';
import mutations from './auth.mutationlist';

export default {
  resetPassword: ({ commit }, { credentials, url }) => new Promise(
    (resolve, reject) => router.app.$http.post(url || 'auth/password/email', credentials)
      .then((response) => {
        if (response.data) {
          resolve(response);
        } else {
          reject(response);
        }
      }, (error) => {
        commit(mutations.LOGOUT);
        reject(error);
      }),
  ),

  fetchUser: ({ commit }) => new Promise(
    (resolve, reject) => router.app.$http.get('user/me', {
      params: {
        file: true,
        contact_info: true,
      },
    })
      .then((response) => {
        if (response && response.data) {
          commit(mutations.SET_USER, response.data);
        }
        resolve(response.data);
      }, (error) => {
        reject(error);
      }),
  ),
};



// WEBPACK FOOTER //
// ./src/store/auth/auth.actions.js